import { useEffect } from 'react';
import { Preferences } from '@capacitor/preferences';
import { useData } from '@/context/DataContext';
import { migrateGuide } from '@/lib/quickGuide';

export function useGuideHistory() {
  const { db } = useData();
  const onboarded = db?.settings?.prefs?.onboarded;
  useEffect(() => {
    if (onboarded === undefined) return;
    Preferences.get({ key:'bp-guide-v1' }).then(async ({ value }) => {
      let old; try { old = JSON.parse(value); } catch { /* safe migration below */ }
      if (!old) await Preferences.set({ key:'bp-guide-v1', value:JSON.stringify(migrateGuide(null, onboarded)) });
    }).catch(() => {});
  }, [onboarded]);
}
